<ul class="breadcrumb breadcrumb-page">
  <li><a href="#">{{'app.Home' | translate}}</a></li>
  <li class="active">{{'pageHeader.hcps' | translate}}</li>
</ul>

<div class="page-header">
  <div class="row">
    <h1 class="col-xs-12 col-sm-4 text-center text-left-sm">HCP edit requests History</h1>
  </div>
</div>

<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'app.searchTitle' | translate}}</span>
  </div>

  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-6">
          <input type="text"
                 name="name"
                 [(ngModel)]="search.searchText"
                 placeholder="{{'app.search' |translate}}"
                 #name="ngModel"
                 autocomplete="off"
                 class="form-control" />
        </div>
        <div class="col-sm-3 margin-top-10 cursor-pointer" (click)="openFilterModal()">
          <span class="margin-right-7 filter-span">{{'app.Filter' | translate}}</span>
          <i class="fa fa-filter" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="panel panel-success widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'app.searchResult' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-12">
          <p-table #dt [value]="rows" [responsive]="true" sortMode="multiple" [paginator]="true" [rows]="pageSize">
            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" width={{col.width}} style="text-align:center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th width="8%" style="text-align:center" class="table-edit">{{'View' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr *ngIf="rows.length>0 && displayMode==2">
                <td>{{ row.hcpName }}</td>
                <td *ngIf="showEnglishName">{{ row.englishName }}</td>
                <td>{{ row.phone }}</td>
                <td>{{ row.email }}</td>
                <td>{{ row.specialityName }}</td>
                <td>{{ row.requestedByName }}</td>
                <td>{{ row.requestDate | date :'dd/MM/yyyy HH:mm'}}</td>
                <td>{{ statusLabel(row.status) }}</td>
                <td>{{ row.reviewedByName }}</td>
                <td>{{ row.reviewDate | date :'dd/MM/yyyy HH:mm'}}</td>
                <td style="text-align:center"><a href="javascript:;" (click)="diffModal.show(row.editRequestId)"><i class="fa fa-eye fa-lg font-size-20"></i></a></td>
              </tr>
              <tr *ngIf="rows.length==0 && displayMode==2">
                <td colspan="11">{{'app.NoDataFound' | translate}}</td>
              </tr>
              <tr *ngIf="displayMode==1">
                <td colspan="11">
                  <div class="row col-sm-12 padding-sm-hr">
                    <div class="container text-center">
                      <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="displayMode==3">
                <td colspan="11">
                  <div class="alert alert-danger alert-dark">
                    <button type="button" class="close" data-dismiss="alert">×</button>
                    {{'app.ServerError' |translate}}.
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #filterModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title">{{'app.Filter' | translate}}</h1>
      </div>
      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">
        <div class="row">
          <div class="col-sm-6">
            <label class="control-label">{{'app.name' | translate}} </label>
            <input type="text"
                   name="name"
                   [(ngModel)]="search.searchText"
                   placeholder="{{'app.name' |translate}}"
                   #name="ngModel"
                   autocomplete="off"
                   class="form-control" />
          </div>
          <div class="col-sm-6">
            <label class="control-label">Status</label>
            <span class="ui-fluid">
              <p-dropdown [options]="statuses"
                          placeholder="Status"
                          emptyFilterMessage="No results found"
                          showClear="true"
                          styleClass="wid100"
                          name="status"
                          [(ngModel)]="search.status"
                          [filter]="true" optionLabel="name">
              </p-dropdown>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <label class="control-label">{{'reports.users' | translate}} </label>
            <span class="ui-fluid">
              <p-dropdown [options]="users"
                          name="requestedByUser"
                          styleClass="wid100"
                          placeholder="User"
                          emptyFilterMessage="No results found"
                          showClear="true"
                          [(ngModel)]="search.user"
                          [virtualScroll]="true" itemSize="10"
                          [filter]="true" optionLabel="fullName"></p-dropdown>
            </span>
          </div>
          <div class="col-sm-6">
            <label class="control-label">{{'pageHeader.DateFrom' | translate}} </label>
            <div class="input-group date">
              <input type="text"
                     name="startDate"
                     [(ngModel)]="search.startDate"
                     #dpYMD="bsDatepicker"
                     bsDatepicker
                     [bsConfig]="{dateInputFormat: 'YYYY-MM-DD' }" class="form-control" autocomplete="off">
              <span class="input-group-btn date-label">
                <button class="btn date-btn" (click)="dpYMD.toggle()" type="button"><i class="fa fa-calendar"></i></button>
              </span>
            </div>
          </div>
          <div class="col-sm-6">
            <label class="control-label">{{'pageHeader.DateTo' | translate}}</label>
            <div class="input-group date">
              <input type="text"
                     name="endDate"
                     [(ngModel)]="search.endDate"
                     #dpYMD1="bsDatepicker"
                     bsDatepicker
                     [bsConfig]="{dateInputFormat: 'YYYY-MM-DD' }" class="form-control" autocomplete="off">
              <span class="input-group-btn date-label">
                <button class="btn date-btn" (click)="dpYMD1.toggle()" type="button"><i class="fa fa-calendar"></i></button>
              </span>
            </div>
          </div>
        </div>
        <div class="panel-footer margin-left-20 margin-top-20">
          <button type="button" (click)="hideFilterModal()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
          <button type="button" class="btn btn-save" (click)="searchFilterModal()">{{'app.Search' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<crm-hcp-edit-request-diff #diffModal></crm-hcp-edit-request-diff>
